import React from "react"
import ReactHtmlParser, { convertNodeToElement } from "react-html-parser"
import Video from "./video"

const BASIC_STYLING_TAGS = [
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "a",
  "span",
  "b",
  "strong",
  "i",
  "em",
  "u",
  "ul",
  "ol",
  "li",
  "p",
  "br",
  "s",
  "del",
]

/** @type {import('react-html-parser').Transform} */
const basic = (node, index) => {
  if (!node || node.type !== "tag") {
    return
  }

  switch (node.name) {
    case "img":
      return ((
        <img
          key={index}
          {...node.attribs}
          className="img-thumbnail img-responsive"
        />
      ))
    case "iframe":
      if ((node.attribs.src || "").match(/youtube\.com\/embed/)) {
        const thumb = node.attribs["data-poster"]
        const src = node.attribs.src
        return (<Video showPlayIcon={true} key={index} {...{ thumb, src }} />)
      }
    case "video":
      const { poster } = node.attribs
      const sources = node.children
        .filter(node => node.name === "source")
        .map(({ attribs: { src, type } }) => ({ src, type }))
      return ((
        <Video showPlayIcon={true} key={index} src={sources} thumb={poster} />
      ))
    default:
      if (!BASIC_STYLING_TAGS.includes(node.name)) {
        // reset to a basic span for everything other than the allowed basic tags
        node.name = "span"
        return convertNodeToElement(node, index, basic)
      }
  }
}

/**
 * @type {{[key:string]: import('react-html-parser').Transform}}
 */
const PRESETS = {
  basic,
}

/**
 * @returns {JSX.Element}
 */
const HtmlToReact = ({
  transform = null,
  preset = null,
  html = "",
  inline = false,
  // only when inline
  as = "p",
  // only when inline
  className = "",
}) => {
  const options = {}
  let wrapAs = null

  if (preset && PRESETS[preset]) {
    transform = PRESETS[preset]
  }

  if (inline) {
    options.preprocessNodes = nodes => {
      if (!nodes || nodes.length === 0) {
        return nodes
      }

      const [node] = nodes

      if (node.type === "text") {
        wrapAs = as
      } else if (node.type === "tag" && node.name !== as) {
        node.name = as
      }

      if (!wrapAs && className) {
        node.attribs["className"] = className
      }

      node.next = null
      return [node]
    }
  }

  const parsed = ReactHtmlParser(html, { ...options, transform })

  if (wrapAs) {
    return React.createElement(wrapAs, { className }, parsed)
  } else {
    return <React.Fragment>{parsed}</React.Fragment>
  }
}

export { HtmlToReact }
